import { Injectable } from '@angular/core';

import { BusService } from '../bus.service';
import { EventsService } from '../events.service';
import { RequestService } from '../request.service';

@Injectable()
export class NotificationRequestService {
  api = {
    root: '/users/notifications',
    read: '/read',
    seen: '/seen',
  };

  constructor(
    private client: RequestService,
    private bus: BusService,
    private events: EventsService,
  ) {
    this.subscribe();
  }

  read(notification: any) {
    this.client.patch<any, any>({
      uri: this.api.root + `/${notification._id}` + this.api.read,
      body: {},
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.user.notifications.read.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.user.notifications.read.failure,
            error.error,
          ),
      },
    });
  }

  seen() {
    this.client.patch<any, any>({
      uri: this.api.root + this.api.seen,
      body: {},
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.user.notifications.seen.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.user.notifications.seen.failure,
            error.error,
          ),
      },
    });
  }

  private subscribe() {
    this.bus.subscribe(
      this.events.requested.action.user.notifications.read,
      this.read.bind(this),
    );
    this.bus.subscribe(
      this.events.requested.action.user.notifications.seen,
      this.seen.bind(this),
    );
  }
}
